export default{
    grupos: [],
    grupoSelec: null,
    ordenGrupo: null
}